import { Flow_0_0_2 } from '@flexus/core';

export const BUI_87: Flow_0_0_2 = {
	id: '87',
	name: 'quote_approved_tl',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for team leader to accept'
		}
	},
	startNode: '',
	nodes: {}
};
